/**
 * Package buying configuration - vars at top for easy maintenance
 */

// Base route for package buying (full page like login, requires auth)
const PACKAGE_BUY_BASE = '/buy';

// Package definitions: tokens prominent, money minimal — more tokens, less money
export const PACKAGES = {
  welcome: {
    route: `${PACKAGE_BUY_BASE}/welcome`,
    pathSegment: 'welcome',
    title: 'WELCOME PACKAGE',
    subtitle: '150 tokens — best value for first join!',
    amountToPay: 10,
    bonusAmount: 5,
    depositAmount: 10,
    tokenAmount: 150,
    tokenValue: '15 tokens per €',
    className: 'package-welcome',
  },
  bonus: {
    route: `${PACKAGE_BUY_BASE}/bonus`,
    pathSegment: 'bonus',
    title: 'BONUS PACKAGE',
    subtitle: '800 tokens — we double it for free!',
    amountToPay: 40,
    bonusAmount: 40,
    depositAmount: 40,
    tokenAmount: 800,
    tokenValue: '20 tokens per €',
    className: 'package-bonus',
  },
  wise: {
    route: `${PACKAGE_BUY_BASE}/wise`,
    pathSegment: 'wise',
    title: 'WISE PACKAGE',
    subtitle: '400 tokens — show off your knowledge!',
    amountToPay: 25,
    bonusAmount: 15,
    depositAmount: 25,
    tokenAmount: 400,
    tokenValue: '16 tokens per €',
    className: 'package-wise',
  },
};

// Helper to get package by path segment
export const getPackageByPath = (pathSegment) =>
  Object.values(PACKAGES).find((p) => p.pathSegment === pathSegment) ?? null;

// All package buying path segments (for route matching)
export const PACKAGE_BUY_PATHS = Object.values(PACKAGES).map((p) => p.pathSegment);

// Full buy URL for redirects (uses REACT_APP_PUBLIC_URL in dev so parent iframe redirect works)
export const getBuyUrl = (pathSegment) => {
  const base = process.env.REACT_APP_PUBLIC_URL || window.location.origin;
  return `${base.replace(/\/$/, '')}/buy/${pathSegment}`;
};
